export const COMMON_FIELD_TYPES = {
  TEXT_FIELD: "text",
  EMAIL_FIELD: "email",
  PASSWORD_FIELD: "password",
  CONFIRM_PASSWORD: "confirmPassword",
  PHONE: "phoneNumber",
  REQUIRED_FIELD: "requiredField",
  BOOLEAN_FIELD: "booleanField",
  NUMBER_FIELD: "number",
  URL: "url",
  DROPDOWN: "dropdown",
  DATE_PICKER: "datePicker",
  TIME_PICKER: "timePicker",
  ID_NUMBER: "idNumber",
  EMAIL_OR_PHONE: "emailOrPhone",
  CHECKBOX: "checkbox",
  FIRST_NAME: "firstName", // added
  LAST_NAME: "lastName",
  FULL_NAME: "fullName",
  CURRENCY: "currency", // added
  JOB_TITLE: "jobTitle",
  ORG_NAME: "orgName",
};
